import React, { useContext } from 'react';
import { AdminContext } from '../../../context/AdminContext';
import AppIcons from '../../../icons';
import zip from '../../../../../assets/imgs/fileTypes/zip.png';
import rar from '../../../../../assets/imgs/fileTypes/rar.png';
import doc from '../../../../../assets/imgs/fileTypes/doc.png';
import pdf from '../../../../../assets/imgs/fileTypes/pdf.png';
import mp3 from '../../../../../assets/imgs/fileTypes/mp3.png';

import files from '../../../../../assets/imgs/fileTypes/files.svg';
import players from '../../../../../assets/imgs/fileTypes/players.svg';

import SHARED from '../../../constants';
import styles from './styles.module.css';
import hasFarsiCharacters from '../../../functions/hasFarsiCharacters';
import CreateImageSrc from '../../../functions/CreateImageSrc';
import SharedFunc from '../../../functions/SharedFunc';

export default function ReplyBox(props) {
  const { content, themeColor } = useContext(AdminContext);
  let english = /[a-zA-Z]/g;
  return (
    <>
      {props?.replyValue?.id?.length != 0 && (
        <div className={`replyBox ${'modalHeaderBg text-white'}  rtl`}>
          {/* <img
          alt="frowardicon"
          src={'/imgs/login/reply-or-forward.svg'}
          width={15}
          height={15}
          containerclassName={`flex flex-row justify-center items-center h-auto rotate-[180deg]  ${
            themeColor != 'white' && 'makeWhite'
          }`}
        /> */}

          <AppIcons.replyForwardIcon
            width={20}
            height={20}
            className={
              // props?.direction == 'rtl'
              //   ?
              ` noFilterSvg ${styles.marginLeft}`
              // : `noFilterSvg rotate-180 ${styles.marginRight}`
            }
            fill={'#000'}
          />

          <div
            className={`flex ${
              props?.replyValue?.file
                ? 'flex-row justify-start items-center '
                : 'flex-col justify-start items-start '
            }
            ${
              // props?.direction == 'rtl'
              //   ?
              `text-right  ${styles.borderRight}`
              // :
              //  `text-left ml-auto ${styles.borderLeft}`
            }`}
          >
            <p>{content.replyToMessage}</p>
            {props?.replyValue?.message ? (
              <p
                className={`${
                  hasFarsiCharacters(props?.replyValue?.message) == false &&
                  'text-left flex flex-row justify-end'
                } ${styles.displayFlex} `}
              >
                {props?.replyValue?.typeId == 3
                  ? JSON.parse(props?.replyValue?.message)?.name
                  : props?.replyValue?.typeId == 4
                  ? SHARED?.copy_URL +
                    '/video/play/' +
                    JSON.parse(props?.replyValue?.message)?.uuid
                  : props?.replyValue?.message}
              </p>
            ) : (
              <>
                {props?.replyValue?.file?.fileExtension?.type == 'image' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile ${styles.imageStyle}`}
                      src={`${SHARED?.socketServerImage}${CreateImageSrc(
                        props?.replyValue?.file?.name
                      )}`}
                    />
                    {/* <p>{props?.replyValue?.file?.name}</p> */}
                  </div>
                )}

                {props?.replyValue?.file?.fileExtension?.type == 'video' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    {/* <video
                      className={`replyFile ${styles.imageStyle}`}
                      src={`${SharedFunc(
                        props?.replyValue?.file?.serverId,
                        'socketServerVideo'
                      )}${props?.replyValue?.file?.name}`}
                      // controls
                    /> */}
                    <img
                      className={`replyFile ${styles.imageStyle}`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={files}
                    />
                    {/* <p>{props?.replyValue?.file?.name}</p> */}
                  </div>
                )}

                {props?.replyValue?.file?.fileExtension?.type == 'music' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={players}
                    />
                    <p className={`${styles.name}`}>
                      {props?.replyValue?.file?.name}
                    </p>
                  </div>
                )}
                {props?.replyValue?.file?.fileExtension?.type == 'zip' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={files}
                    />
                    <p className={`${styles.name}`}>
                      {props?.replyValue?.file?.name}
                    </p>
                  </div>
                )}
                {props?.replyValue?.file?.fileExtension?.type == 'rar' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={files}
                    />
                    <p className={`${styles.name}`}>
                      {props?.replyValue?.file?.name}
                    </p>
                  </div>
                )}

                {props?.replyValue?.file?.fileExtension?.type == 'doc' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={files}
                    />
                    <p className={`${styles.name}`}>
                      {props?.replyValue?.file?.name}
                    </p>
                  </div>
                )}

                {props?.replyValue?.file?.fileExtension?.type == 'pdf' && (
                  <div
                    className={`flex flex-row-reverse justify-end items-center`}
                  >
                    <img
                      className={`replyFile`}
                      // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                      // controls
                      src={files}
                    />
                    <p className={`${styles.name}`}>
                      {props?.replyValue?.file?.name}
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
          <AppIcons.closeIcon
            width={12}
            height={12}
            onClick={() => {
              props?.setReplyValue({ id: '' });
            }}
            className={`noFilterSvg cursor-pointer`}
            fill={'#000'}
          />
        </div>
      )}
    </>
  );
}
